module.exports = __webpack_public_path__ + "assets/15c1653129cc29a1207e6b2e1080acd1.svg";